/**
 * TableSkeletonLoader
 * Reusable skeleton loader for facturation table views
 */

import React from 'react';
import '../../facturation.css';

interface TableSkeletonLoaderProps {
  rows?: number;
  columns?: number[];
}

export const TableSkeletonLoader: React.FC<TableSkeletonLoaderProps> = ({
  rows = 5,
  columns = [100, 70, 200, 90, 100, 100, 100, 80], // Default invoice table columns
}) => {
  return (
    <div className="fact-results-container">
      <div className="fact-table">
        {/* Render skeleton rows */}
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div
            key={rowIndex}
            className="fact-table-row"
            style={{ cursor: 'default' }}
          >
            {columns.map((width, colIndex) => (
              <div key={colIndex}>
                <div
                  className="animate-pulse bg-gray-200 rounded"
                  style={{
                    height: '16px',
                    width: `${Math.min(width, 100)}%`,
                  }}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableSkeletonLoader;
